import { defineStore } from 'pinia';

interface PageState {
  routeData: any;
  parentRouteData: any;
}

export const usePageStore = defineStore('page', {
  state: (): PageState => ({
    routeData: null,
    parentRouteData: null,
  }),
});
